export default __webpack_public_path__ + "static/media/vivekpic.489dec27.jpeg";